<template>
  <div id="app">
    <!-- <Header v-if="$route.meta.showHeader !== false" /> -->

    <!-- 页面内容 -->
    <router-view />
  </div>
</template>

<script>
// import Header from '@/components/Header.vue'

export default {
  name: 'App',
  // components: {
  //   Header
  // }
}
</script>


